import { Mapper } from "../../../../base/utils/mapper";
import { DataBasicProfileResultModel } from "../../../../domain/models/user/data-basic-profile-result.model";
import { DataBasicProfileResultEntity } from "../entities/data-basic-profile-result.entity";

export class DataBasicProfileResultImplementationRepositoryMapper extends Mapper<DataBasicProfileResultEntity, DataBasicProfileResultModel> {
    mapFrom(param: DataBasicProfileResultEntity): DataBasicProfileResultModel {
        return {
            data:param.data,
            isSuccess: param.isSuccess,
            message: param.message,
            errors:param.errors
        };
    }
    mapTo(param: DataBasicProfileResultModel): DataBasicProfileResultEntity {
        return {
            data:param.data,
            isSuccess: param.isSuccess,
            message: param.message,
            errors:param.errors
        }
    }
}
